const baseURL = process.env.VUE_APP_API_URL || 'https://www.listabell.com'


export default {
    baseURL: baseURL
}
